(function () {
  if (window.__productCustomerGalleryInit) {
    return;
  }

  window.__productCustomerGalleryInit = true;

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.galleryReady === "true") {
      return;
    }

    const modalSelector = gallery.dataset.galleryModal || "";
    const modal = modalSelector ? document.querySelector(modalSelector) : null;
    const thumbs = Array.from(gallery.querySelectorAll("[data-gallery-thumb]"));
    const moreButton = gallery.querySelector("[data-gallery-thumb-more]");

    if (!modal || !thumbs.length) {
      return;
    }

    function openModalByMediaId(mediaId, opener) {
      const fallbackMediaId = thumbs[0]?.dataset.mediaId;
      const targetMediaId = mediaId || fallbackMediaId;

      if (modal.setActiveMedia && targetMediaId) {
        modal.setActiveMedia(targetMediaId);
      }

      if (modal.show) {
        modal.show(opener || thumbs[0]);
      }
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", function () {
        openModalByMediaId(thumb.dataset.mediaId, thumb);
      });
    });

    if (moreButton) {
      moreButton.addEventListener("click", function () {
        openModalByMediaId(moreButton.dataset.mediaId, moreButton);
      });
    }

    gallery.dataset.galleryReady = "true";
  }

  function init(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    const galleries = root.querySelectorAll("[data-product-gallery-hre]");
    galleries.forEach(initGallery);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
